export default {
// pt-BR.js
help: {
  faq: "Perguntas frequentes",
  promo: "Promoções",
  contactUs: "Fale Conosco",
  joinCommunity: "Junte-se à Nossa Comunidade",
  help: "Ajuda"
}
};
